import { useModal } from "../_providers/ModalProvider";

const SelectListModal = ({ list, onSelect }: { list: string[], onSelect: (item: string) => void}) => {
    const { closeModal } = useModal();
    
    const handleSelect = (item: string) => {
        onSelect(item);
        closeModal();
    };
    
    return (
        <div>
            {list.map((item, index) => (
                <div key={index} style={{cursor: "pointer"}} className="transaction dark" onClick={() => handleSelect(item)}>
                    {item}
                </div>
            ))}
        </div>
    );
}

export default SelectListModal;